<template>
  <div class="main-container">
    <div class="statuses" v-if="!dailyBasis">
      <div
        class="status noselect"
        v-for="(status, index) in statuses"
        :style="`background: ${status.color}`"
      >
        <span>{{ index }} ({{ status.count }})</span>
      </div>
    </div>
    <div class="day" v-if="!dailyBasis">
      <div class="selected-date">{{ formattedDate }}</div>
      <div class="date-selector-container">
        <button @click="goToDay()">
          {{ moment(this.currentTime).format("[Today,] Do MMMM") }}
        </button>
        <button class="arrow" @click="goToDay('back')">&larr;</button>
        <button class="arrow" @click="goToDay('next')">&rarr;</button>
      </div>
    </div>
    <div class="filter" v-if="!noData && !loading && !dailyBasis">
      <div class="search">
        <input
          type="text"
          placeholder="Rechercher par nom ou N° de licence"
          v-model="searchQuery"
          @input="search(searchQuery)"
        />
      </div>
      <div class="station-filter">
        <select v-model="selectedStation">
          <option value="0">No station selected</option>
          <option v-for="(station, index) in allStations" :key="index" :value="station.id">{{ station.name }}</option>
        </select>
      </div>
    </div>
    <table class="noselect">
      <tr>
        <th class="driver-name">{{ dailyBasis ? "Day" : "Driver's name" }}</th>
        <th class="taxi-number" v-if="!dailyBasis">Taxi No.</th>
        <th style="padding: 0">
          <div
            class="timing-container"
            id="timing"
            @scroll="scrollOthers($event)"
          >
            <div class="times">
              <div
                class="current-time-indicator"
                :style="`left:${currentTimeIndicator}px`"
                v-if="isToday && !dailyBasis"
              ></div>
              <div class="time" v-for="(_hour, index) in 24" :key="index">
                {{ index }}:00
                <div class="half-hour-divider"></div>
              </div>
            </div>
          </div>
        </th>
      </tr>
      <tr v-if="noData && !loading" class="noOrders">
        <td :colspan="dailyBasis ? 2 : 3">
          <p style="margin: 0 !important">
            Sorry, there is no data in this day
          </p>
        </td>
      </tr>
      <tr v-else-if="loading" class="noOrders">
        <td :colspan="dailyBasis ? 2 : 3">
          <p style="margin: 0 !important">Loading...</p>
        </td>
      </tr>
      <tr v-for="(driver, index) in filteredDrivers" :key="index">
        <td>{{ driver.full_name || driver.day }}</td>
        <td v-if="driver.taxi_number">{{ driver.taxi_number }}</td>
        <td style="padding: 0">
          <div
            class="timing-container"
            :id="index"
            @scroll="scrollOthers($event)"
          >
            <div class="statuses-container">
                <!-- <div class="popper">
                  {{
                    status.booking
                      ? `#${status.booking.id}`
                      : "No trips during this period"
                  }}
                </div> -->
                <div
                 v-for="status in driver.check_log"
                  class="status"
                  :content='status.booking ? `#${status.booking.id}` : "No trips during this period"'
                  slot="reference"
                  :style="`left:${calculateStartPoint(
                    status.from_datetime
                  )}px; width:${calculateWidth(
                    status.from_datetime,
                    status.to_datetime
                  )}px; background: ${getColor(status.status)};`"
                  :class="checkEnd(status.to_datetime)"
                ></div>
            </div>
            <div class="times">
              <div
                class="current-time-indicator"
                :style="`left:${currentTimeIndicator}px`"
                v-if="isToday"
              ></div>
              <div class="time" v-for="(_hour, index) in 24" :key="index"></div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div
      class="booking-tooltip"
      :class="[showToolTip && 'show-tooltip']"
      ref="bookingTooltip"
      :style="`left: ${clientX}px; top: ${clientY}px;`"
    >
      {{ toolTipMessage }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/constants/api";
import moment from "moment";
import VuePopper from "popper.js";
let CancelToken = axios.CancelToken;
let cancel;

export default {
  name: "TimelineComponent",
  props: {
    dailyBasis: {
      required: false,
      default: false,
    },
    captainId: {
      required: false,
    },
  },
  components: {
  	'popper': VuePopper
  },
  data() {
    return {
      colors: {
        FREE: "#2EB7B7",
        IN_STATION: "#F7C806",
        AT_DESTINATION: "#E10015",
        BUSY: "#16458E",
      },
      statuses: {},
      drivers: {},
      currentTime: new Date(),
      selectedTime: null,
      eachMinutePixel: (184 * 24) / 1440,
      scrollPosition: 0,
      timingWidth: 0,
      timingScrollWidth: 0,
      loading: false,
      searchQuery: "",
      allStations: [],
      selectedStation: "0",
      clientX: 0,
      clientY: 0,
      toolTipMessage: "",
      showToolTip: false,
      clickedBounds: null,
      // filteredDrivers: {}
    };
  },
  computed: {
    currentTimeIndicator() {
      return (
        (this.currentTime.getHours() * 60 + this.currentTime.getMinutes()) *
        this.eachMinutePixel
      );
    },
    filteredDrivers() {
      if(!this.dailyBasis) {
        if (this.searchQuery) return this.search(this.searchQuery);
        else if (this.selectedStation !== "0")
          return this.selectStation(this.selectedStation);
        else return this.drivers;
      } else {
        return Object.values(this.drivers).sort(function (a, b) {
          return b.day - a.day;
        })
      }
    },
    formattedDate() {
      let time = moment(this.selectedTime).format("dddd[,] Do MMMM");
      return time.charAt(0).toUpperCase() + time.slice(1);
    },
    isToday() {
      return moment(this.currentTime).format("YYYY[-]MM[-]DD") ==
        moment(this.selectedTime).format("YYYY[-]MM[-]DD") && !this.dailyBasis
        ? true
        : false;
    },
    noData() {
      return Object.keys(this.drivers).length
        ? false
        : this.loading
        ? false
        : true;
    },
  },
  created() {
    moment.locale("fr");
    this.resetStatusesCount();
    this.loadStations();
  },
  mounted() {
    this.selectedTime = this.currentTime;
    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  },
  unmounted() {
    window.removeEventListener("mousemove", () => {});
  },
  watch: {
    scrollPosition(newScrollPosition) {
      this.setScrollPosition(newScrollPosition);
    },
    selectedTime(newTime) {
      if (this.isToday) {
        this.timingWidth = document.getElementById("timing").offsetWidth;
        this.timingScrollWidth = document.getElementById("timing").scrollWidth;
        this.scrollPosition = this.currentTimeIndicator - this.timingWidth / 2;
      }
      this.resetStatusesCount();
      this.loadData(newTime);
    },
    filteredDrivers() {
      this.setScrollPosition(this.scrollPosition);
      this.resetStatusesCount();
      Object.entries(this.filteredDrivers).forEach(([key, value]) => {
        let checkLogCopy = [...value.check_log];
        let lastLog = checkLogCopy.reverse()[0];
        if (lastLog.to_datetime == null) {
          this.statuses[lastLog.status].count++;
        }
      });
    },
  },
  methods: {
    loadStations() {
      axios.get(this.api.ACTIONS.ALL_STATIONS).then((response) => {
        this.allStationsData = response.data.data.stations;
        for (let i = 0; i < this.allStationsData.length; i++) {
          let { id, name } = response.data.data.stations[i];
          this.allStations.push({
            id: id,
            name: name
          });
        }
      });
    },
    openToolTip(info, evt) {
      this.clickedBounds = evt.target.getBoundingClientRect();
      this.toolTipMessage = info;
      this.showToolTip = !this.showToolTip;
    },
    changeTooltipPos(evt) {
      this.clientX = this.clickedBounds.left;
      this.clientY = this.clickedBounds.top;
    },
    resetStatusesCount() {
      this.statuses = {
        FREE: {
          color: "#2EB7B7",
          count: 0,
        },
        IN_STATION: {
          color: "#F7C806",
          count: 0,
        },
        AT_DESTINATION: {
          color: "#E10015",
          count: 0,
        },
        BUSY: {
          color: "#16458E",
          count: 0,
        },
      };
    },
    setScrollPosition(scroll) {
      document.getElementById("timing").scrollLeft = scroll;
      if (!this.noData && !this.loading) {
        Object.keys(this.filteredDrivers).forEach((o) => {
          window.requestAnimationFrame(function () {
            document.getElementById(o).scrollLeft = scroll;
          });
        });
      }
    },
    loadData(date) {
      let formattedDate = moment(date);
      let params = {
        date: formattedDate.format("YYYY[-]MM[-]DD"),
      };
      if (this.dailyBasis && this.captainId) {
        params["monthly"] = 1;
        params["daily_basis"] = 1;
        params["captain_id"] = this.captainId;
      }
      this.loading = true;
      this.drivers = {};
      axios
        .get(api.ACTIONS.CAPTAINS_STATUSES_TIMELINE, {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.drivers = res.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.setScrollPosition(this.scrollPosition);
        });
    },
    scrollOthers(evt) {
      this.scrollPosition = evt.target.scrollLeft;
    },
    getColor(status) {
      return this.colors[status];
    },
    calculateWidth(from, to) {
      if (to && moment(to).format("dd") == moment(from).format("dd")) {
        let diff = Math.abs(new Date(from) - new Date(to));
        return Math.floor(diff / 1000 / 60) * this.eachMinutePixel;
      } else if (this.isToday) {
        return this.currentTimeIndicator - this.calculateStartPoint(from);
      } else {
        return this.timingScrollWidth - this.calculateStartPoint(from);
      }
    },
    calculateStartPoint(from) {
      let time = new Date(from);
      return Math.floor(
        (time.getHours() * 60 + time.getMinutes()) * this.eachMinutePixel
      );
    },
    checkEnd(to) {
      return to ? "" : "end";
    },
    goToDay(date = null) {
      cancel();
      if (date === "next")
        this.selectedTime = moment(this.selectedTime).add("1", "days");
      else if (date === "back")
        this.selectedTime = moment(this.selectedTime).subtract("1", "days");
      else this.selectedTime = moment(this.currentTime);
    },
    selectStation(station) {
      if (station !== "0") {
        let obj = {};
        Object.entries(this.drivers).forEach(([key, value]) => {
          let checkLogCopy = [...value.check_log];
          let lastLog = checkLogCopy.reverse()[0];
          if (lastLog.to_datetime == null) {
            if (lastLog.status == "IN_STATION" && lastLog.station == station)
              obj[key] = value;
          }
        });
        return obj;
      } else if (station === "0") return this.drivers;
    },
    search(query) {
      if (query !== "") {
        let obj = {};
        let lowerCaseQuery = query.toLowerCase();
        Object.entries(this.drivers).forEach(([key, value]) => {
          if (
            value.full_name.toLowerCase().search(lowerCaseQuery) != -1
            // value.taxi_number.toLowerCase().search(lowerCaseQuery) != -1
          )
            obj[key] = value;
        });
        return obj;
      } else if (query === "") {
        return this.drivers;
      }
    },
    // alert(a) {
    //   console.log(a)
    // }
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  float: left;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 18px 25px;
  gap: 20px;

  .statuses {
    width: auto;
    height: 42px;
    float: left;
    display: flex;
    flex-direction: row;
    gap: 10px;
    .status {
      padding: 13px 18px;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      float: left;
      color: white;
      border-radius: 9999px;
    }
  }

  .day {
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    .selected-date {
      float: left;
      font-size: 18px;
      font-weight: 700;
    }

    .date-selector-container {
      display: flex;
      flex-direction: row;
      gap: 10px;
      button {
        height: 26px;
        font-size: 12px;
        border-radius: 10px;
        background: #fff;
        border: 1px solid #c1c5d8;
        padding: 7px;
        line-height: 12px;

        &[class="arrow"] {
          width: 26px;
          padding: 0;
        }
      }
    }
  }

  .filter {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    .search {
      width: 50%;
      float: left;
      input {
        width: 48%;
        max-width: 300px;
        padding: 16px;
        border-radius: 10px;
        background-color: #f7f8fa;
        border: 1px solid #c1c5d8;
        font-size: 14px;
        outline: none;
      }
    }

    .station-filter {
      width: 50%;
      float: right;
      position: relative;

      select {
        float: right;
        border-radius: 10px;
        background: #fff;
        outline: none;
        font-size: 14px;
        padding: 16px;
        padding-right: 28px;
        box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
        cursor: pointer;
        appearance: none;
      }

      &::after {
        content: "";
        position: absolute;
        background-image: url("../assets/down-arrow.svg");
        background-repeat: no-repeat;
        background-position: center;
        width: 12px;
        height: 12px;
        right: 12px;
        top: 50%;
        pointer-events: none;
        transform: translateY(-50%);
      }
    }
  }

  table {
    width: 100%;
    height: auto;
    float: left;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;

    td,
    th,
    tr {
      border: 1px solid #c1c5d8;
      height: 45px;
      overflow: hidden;

      .current-time-indicator {
        top: 0;
        width: 2px;
        background: #e10015;
        height: 100%;
        position: absolute;
        z-index: 18;
      }
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 10px !important;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 10px !important;
    }

    tr:first-child th:last-child {
      border-top-right-radius: 10px !important;
    }

    tr:first-child th:first-child {
      border-top-left-radius: 10px !important;
    }

    tr:nth-child(even) {
      background-color: #f7f8fa;
    }

    td {
      padding: 14px;
      padding-left: 16px;
    }

    .driver-name {
      width: 13%;
      max-width: 142px;
      min-width: 100px;
      padding: 16px;
      text-align: left;
    }

    .taxi-number {
      width: 10%;
      padding: 16px;
      max-width: 142px;
      text-align: left;
    }

    .timing-container {
      width: 100%;
      height: 100%;
      max-width: 100%;
      position: relative;
      overflow-x: overlay;

      .status {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: 12px;
        border-radius: 9999px;
        z-index: 8;
        cursor: pointer;
        transition: 0.2s;

        &.end {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
      }

      .times {
        width: max-content;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

        .time {
          width: 184px;
          height: 100%;
          float: left;
          padding: 16px 22px;
          text-align: left;
          position: relative;

          .half-hour-divider {
            height: 10px;
            width: 1px;
            background: #c1c5d8;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          &:not(:last-child) {
            border-right: 1px solid #c1c5d8;
          }
        }
      }

      &::-webkit-scrollbar {
        width: 0em;
        height: 0em;
      }
    }

    .noOrders {
      p {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>